<template>
	<div class="main-content">
		<div class="center-body">
			<Nav />

			<div class="row"
				style="position: relative; text-align: center; padding: 0; background: #f8faff; margin: 0; width: 100%;">
				<div style="max-width: 100%; width: 100%; margin: 0;">
					<div style="margin-top: 0; width: 100%;">
						<img src="../../assets/img/zlindex5.png" style="
          width: 100%; 
          height: auto; 
          border-radius: 0; /* 若需要圆角可保留8px，这里取消圆角避免边缘空白 */
          display: block; /* 消除图片底部默认空白 */
          object-fit: cover; /* 确保图片填满容器（若图片比例和容器不一致，会裁剪边缘） */
        " />
					</div>
				</div>
			</div>
			<!-- 第二层（案例介绍板块 - 6张图片轮播） -->
			<div style="margin: 80px auto; min-height: 60px; width: 1200px;">
				<!-- 标题区域 -->
				<div class="row ju-c al-c"
					style="color: #409eff; font-size: 24px; font-weight: bold; position: relative;">
					案例介绍
					<div
						style="width: 60px; height: 2px; background-color: #409eff; position: absolute; bottom: -8px; left: 50%; transform: translateX(-50%);">
					</div>
				</div>

				<!-- 案例内容区域 -->
				<div style="margin-top: 40px;">
					<!-- 案例标题与时间 -->
					<div style="font-size: 20px; font-weight: 600; color: #333;">河北华通科技Maob-MES系统成功导入</div>
					<div style="font-size: 14px; color: #666; margin-top: 8px;">2021年11月8日 •</div>

					<!-- 案例描述 -->
					<div style="font-size: 14px; color: #666; line-height: 22px; margin-top: 15px;">
						通过华通科技MES系统（生产执行系统）的实施，完成了生产计划制定、生产上料、生产过程跟踪、生产经验、成品入库、IQC检验的物流及信息预过程管控。为进一步建立现代企业生产管理思想、理念打下基础，促进企业管理水平的提高，使银盾电子股份有限公司的生产管理业务信息化、自动化、数字化。
					</div>

					<!-- 案例图片与轮播控制 -->
					<div style="margin-top: 20px; display: flex; align-items: center;">


						<div
							style="width: 1200px; height: 400px; background: #e1e8ff; border-radius: 8px; overflow: hidden;">
							<img :src="caseImageList[0]"
								style="width: 100%; height: 100%; object-fit: cover; transition: opacity 0.5s ease;"
								:key="currentImageIndex" @error="handleImageError" />
						</div>

						
					</div>


				</div>
			</div>

			<!-- 第三层 -->
			<!-- <div class="hxyx-box">
				<div class="row ju-c al-c" style="color: #fff;font-size: 32px;font-weight: bold;">
					资质能力
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #fff;"></div>
				</div>
				<div class="row ju-c al-c" style="margin-top: 25px;">
					<div class="item-no" style="font-size: 18px;color: #fff;line-height: 32px;">
						国家高新技术企业, 50余项软件著作权，CMMI3软件认证<br>专利申请2项,ISO9001,ISO27001信息安全管理体系认证证书
					</div>
				</div>
			</div> -->
			<!-- 第三层（服务客户板块） -->
			<div class="hxyx-box" style="height: auto; padding: 80px 0; background: #fff;">
				<!-- 标题区域 -->
				<div class="row ju-c al-c"
					style="color: #409eff; font-size: 28px; font-weight: bold; position: relative;">
					服务客户
					<div
						style="width: 60px; height: 2px; background-color: #409eff; position: absolute; bottom: -8px; left: 50%; transform: translateX(-50%);">
					</div>
				</div>
				<div class="row ju-c al-c" style="margin-top: 15px; font-size: 14px; color: #666;">
					10多年行业技术积累成就行业口碑，600+用户最优选择！
				</div>

				<!-- 客户Logo区域 -->
				<div style="margin-top: 40px; width: 100%; display: flex; justify-content: center; padding: 0 20px;">
					<!-- banner2 - 缩小尺寸并优化显示效果 -->
					<img src="../../assets/img/zlindex7.png" style="
      max-width: 1200px;  /* 限制最大宽度，适配大屏 */
      height: auto;  /* 保持宽高比 */
      border-radius: 8px;
      object-fit: cover;  /* 防止图片拉伸变形 */
      image-rendering: -webkit-optimize-contrast;  /* 优化图片显示清晰度 */
    " />
				</div>
			</div>
			<!-- 第四层 -->
			<!-- <div class="mfty-box" style="background-color: #f0f0f0;height: 700px;">
				<div class="row ju-c al-c" style="color: #000;font-size: 32px;font-weight: bold;">
					我们的团队
				</div>
				<div class="row ju-c al-c" style="margin-top: 20px;">
					<div class="item-no" style="width: 120px;height: 2px;background-color: #0fbee7;"></div>
				</div>
				<div style="width: 1200px;margin: 0 auto;margin-top: 50px;">
					<div class="row ju-c" >
						<div class="col-no" :class="{'active':index==1}" @mouseenter="enter(1)" @mouseleave="leave" style="width: 270px;padding: 10px;height: 470px;justify-content: flex-start;">
							<img src="../../assets/img/tdImg1.png" />
							<div class="item-no ju-c" :class="{'active':index==1}"  style="color: #000;font-size: 22px;margin-top: 20px;font-weight: bold;">
								专业
							</div>
							<div class="item-no ju-c" :class="{'active':index==1}" style="color: #666;margin-top: 15px;font-size: 16px;line-height: 20px;">
								我们的团队中<br>研发人员的占比超过90%
							</div>
						</div>
						<div class="col-no" :class="{'active':index==2}" @mouseenter="enter(2)" @mouseleave="leave" style="width: 270px;padding: 10px;height: 470px;justify-content: flex-start;margin-left: 40px;">
							<img src="../../assets/img/tdImg2.png" />
							<div class="item-no ju-c" :class="{'active':index==2}" style="color: #000;font-size: 22px;margin-top: 20px;font-weight: bold;">
								年轻
							</div>
							<div class="item-no ju-c" :class="{'active':index==2}" style="color: #666;margin-top: 15px;font-size: 16px;line-height: 20px;">
								我们是一支年轻创新的团队，我们朝气蓬勃，充满青春的力量
							</div>
						</div>
						<div class="col-no" :class="{'active':index==3}" @mouseenter="enter(3)" @mouseleave="leave" style="width: 270px;padding: 10px;height: 470px;justify-content: flex-start;margin-left: 40px;">
							<img src="../../assets/img/tdImg3.png" />
							<div class="item-no ju-c" :class="{'active':index==3}" style="color: #000;font-size: 22px;margin-top: 20px;font-weight: bold;">
								梦想
							</div>
							<div class="item-no ju-c" :class="{'active':index==3}" style="color: #666;margin-top: 15px;font-size: 16px;line-height: 20px;">
								我们是一支有梦想的团队，我们心中都有一个共同的梦想，我们相信成功
							</div>
						</div>
						<div class="col-no" :class="{'active':index==4}" @mouseenter="enter(4)" @mouseleave="leave" style="width: 270px;padding: 10px;height: 470px;justify-content: flex-start;margin-left: 40px;">
							<img src="../../assets/img/tdImg4.png" />
							<div class="item-no ju-c" :class="{'active':index==4}" style="color: #000;font-size: 22px;margin-top: 20px;font-weight: bold;">
								专注
							</div>
							<div class="item-no ju-c" :class="{'active':index==4}" style="color: #666;margin-top: 15px;font-size: 16px;line-height: 20px;">
								我们相信，企业的发展离不开好产品，只有专注，才能做出好产品
							</div>
						</div>
					</div>
				</div>
			</div> -->

			<Foot />
		</div>
	</div>
</template>

<script>
import Nav from "./nav.vue";
import Foot from "./foot.vue";
export default {
	name: "App",
	components: {
		Nav,
		Foot
	},
	data() {
		return {
			curHeight: 0,
			index: 0,
			caseImageList: [
				// "../../assets/img/zlindex6.png"
				require("@/assets/img/zlindex6.png")  // 使用 require
			],
			// 当前显示的图片索引
			currentImageIndex: 0
		};
	},
	watch: {
		windowHeight(val) {
			let that = this;
			console.log("实时屏幕高度：", val, that.windowHeight);
		},
	},
	beforeMount() {
		var h = document.documentElement.clientHeight || document.body.clientHeight;
		this.curHeight = h;
	},
	methods: {
		// 图片加载失败的处理函数
		handleImageError(e) {
			// console.error("图片加载失败：", e.target.src);
			// e.target.src = "http://192.168.25.123:8080/img/zlindex6.4c0979a2.png";
			// 加载失败时显示默认图片
			//  e.target.src = "https://picsum.photos/1000/400?random=0";
		},
		// 上一张图片
		prevImage() {
			if (this.currentImageIndex > 0) {
				this.currentImageIndex--;
			}
		},
		// 下一张图片
		nextImage() {
			if (this.currentImageIndex < this.caseImageList.length - 1) {
				this.currentImageIndex++;
			}
		},
		// 切换到指定图片
		switchImage(index) {
			this.currentImageIndex = index;
		},
		enter(e) {
			this.index = e;
		},
		leave() {
			this.index = 0;
		}
	},
	mounted() {
		var that = this;
		window.onresize = () => {
			return (() => {
				window.fullHeight = document.documentElement.clientHeight;
				that.curHeight = window.fullHeight;
			})()
		};
		console.log("轮播图片列表：", this.caseImageList);
	},
};
</script>

<style scoped>
.main-content {
	min-height: 100%;
	min-width: 1400px;
	width: 100%;
	margin: 0 auto;
	display: block;
	position: absolute;
}

.prduct-box {
	width: 1200px;
	padding-bottom: 100px;
	margin: 0 auto;
}

.center-body {
	margin: 0 auto;
}

.fixed-bottom {
	position: fixed;
	bottom: 0;
}

.hxyx-box {
	height: 793px;
	background-image: url(../../assets/img/gywmbg.png);
	background-size: 100% 100%;
	background-repeat: no-repeat;
	padding-top: 80px;
	text-align: center;
}

.mfty-box {
	height: 600px;
	background-color: #fff;
	padding-top: 60px;
	text-align: center;
}

.active {
	color: #fff !important;
	background-color: #0070FD !important;
}

/* 轮播箭头hover效果优化 */
button:hover {
	color: #409eff !important;
}

/* 图片过渡动画 */
img {
	transition: all 0.5s ease;
}
</style>